"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferCancelOptions = exports.Contract = exports.LocalCluster = exports.StreamType = exports.StreamDirection = exports.Cluster = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var utils_1 = require("./utils");
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
Object.defineProperty(exports, "Cluster", { enumerable: true, get: function () { return wallet_adapter_base_1.WalletAdapterNetwork; } });
var StreamDirection;
(function (StreamDirection) {
    StreamDirection["Outgoing"] = "outgoing";
    StreamDirection["Incoming"] = "incoming";
    StreamDirection["All"] = "all";
})(StreamDirection = exports.StreamDirection || (exports.StreamDirection = {}));
var StreamType;
(function (StreamType) {
    StreamType["Stream"] = "stream";
    StreamType["Vesting"] = "vesting";
    StreamType["All"] = "all";
})(StreamType = exports.StreamType || (exports.StreamType = {}));
var LocalCluster;
(function (LocalCluster) {
    LocalCluster["Local"] = "local";
})(LocalCluster = exports.LocalCluster || (exports.LocalCluster = {}));
var Contract = /** @class */ (function () {
    function Contract(stream) {
        var _a;
        this.magic = stream.magic.toNumber();
        this.version = stream.version.toNumber();
        this.createdAt = stream.createdAt.toNumber();
        this.withdrawnAmount = stream.withdrawnAmount;
        this.canceledAt = stream.canceledAt.toNumber();
        this.end = stream.end.toNumber();
        this.lastWithdrawnAt = stream.lastWithdrawnAt.toNumber();
        this.sender = stream.sender.toBase58();
        this.senderTokens = stream.senderTokens.toBase58();
        this.recipient = stream.recipient.toBase58();
        this.recipientTokens = stream.recipientTokens.toBase58();
        this.mint = stream.mint.toBase58();
        this.escrowTokens = stream.escrowTokens.toBase58();
        this.streamflowTreasury = stream.streamflowTreasury.toBase58();
        this.streamflowTreasuryTokens =
            stream.streamflowTreasuryTokens.toBase58();
        this.streamflowFeeTotal = stream.streamflowFeeTotal;
        this.streamflowFeeWithdrawn = stream.streamflowFeeWithdrawn;
        this.streamflowFeePercent = stream.streamflowFeePercent.toNumber();
        this.partnerFeeTotal = stream.partnerFeeTotal;
        this.partnerFeeWithdrawn = stream.partnerFeeWithdrawn;
        this.partnerFeePercent = stream.partnerFeePercent.toNumber();
        this.partner = stream.partner.toBase58();
        this.partnerTokens = (_a = stream.partnerTokens) === null || _a === void 0 ? void 0 : _a.toBase58();
        this.start = stream.start.toNumber();
        this.depositedAmount = stream.depositedAmount;
        this.period = stream.period.toNumber();
        this.amountPerPeriod = stream.amountPerPeriod;
        this.cliff = stream.cliff.toNumber();
        this.cliffAmount = stream.cliffAmount;
        this.cancelableBySender = stream.cancelableBySender;
        this.cancelableByRecipient = stream.cancelableByRecipient;
        this.automaticWithdrawal = stream.automaticWithdrawal;
        this.transferableBySender = stream.transferableBySender;
        this.transferableByRecipient = stream.transferableByRecipient;
        this.canTopup = stream.canTopup;
        this.name = stream.name;
        this.withdrawalFrequency = stream.withdrawFrequency.toNumber();
    }
    Contract.prototype.unlocked = function (currentTimestamp, decimals) {
        var deposited = (0, utils_1.getNumberFromBN)(this.depositedAmount, decimals);
        if (currentTimestamp < this.cliff)
            return 0;
        if (currentTimestamp > this.end)
            return deposited;
        var streamedBN = this.cliffAmount.add(new bn_js_1.default(Math.floor((currentTimestamp - this.cliff) / this.period)).mul(this.amountPerPeriod));
        var streamed = (0, utils_1.getNumberFromBN)(streamedBN, decimals);
        return streamed < deposited ? streamed : deposited;
    };
    Contract.prototype.remaining = function (decimals) {
        return (0, utils_1.getNumberFromBN)(this.depositedAmount.sub(this.withdrawnAmount), decimals);
    };
    return Contract;
}());
exports.Contract = Contract;
var TransferCancelOptions;
(function (TransferCancelOptions) {
    TransferCancelOptions["Recipient"] = "recipient";
    TransferCancelOptions["Sender"] = "sender";
    TransferCancelOptions["Both"] = "both";
    TransferCancelOptions["Neither"] = "neither";
})(TransferCancelOptions = exports.TransferCancelOptions || (exports.TransferCancelOptions = {}));
